import { ContextService } from '../../product/context';
import { EnrollmentContextService } from '../enrollment-context';
export const consentsMapper = (
	context: ContextService,
	enrollmentContext: EnrollmentContextService
): { name: string; dateTime: string }[] => {
	const filteredServices = enrollmentContext.eligibleServices(context).filter(
		(service) => !enrollmentContext.input.discardedServices.includes(service.id)
	);
	const serviceConsents = filteredServices.reduce(
		(services: string[], service) => {
			services.push(...service.consents.service);
			return services;
		},
		[]
	);
	const consents = serviceConsents.concat(enrollmentContext.input.consents);
	return consents.map((consent) => {
		return { name: consent, dateTime: new Date().toISOString() };
	});
};
